



























import Vue from 'vue'
import 'swiper/css/swiper.min.css'
import { swiper, swiperSlide, Swiper } from 'vue-awesome-swiper'
import { Component, Prop } from 'vue-property-decorator'
import Banner from '@/model/common/banner'
import queryString from 'query-string'

@Component({
  components: {
    swiper,
    swiperSlide
  }
})
export default class PostPage extends Vue {
  @Prop() public bannerList?: Banner[]

  private vm: Vue = this
  private swiperOption = {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    on: {
      click: () => {
        const newSwiper = (this.$refs.mySwiper as Vue).swiper as Swiper
        this.touchBanner(newSwiper.realIndex)
        // vm.handleClickSlide(1);
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  public touchBanner(index: number) {
    if (this.bannerList) {
      const item = this.bannerList[index]
      window.open(item.url)
    }
  }

  public getBannerStyle(item: Banner) {
    return `background-image: url(${item.image})`
  }
}
